import React, { useState, useEffect } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import OrderServices from "../based/services/OrderServices";
import Common from "../based/Common";

function PickProductModal({ show, onClose, onConfirm, orderId }) {
    const [selectedProducts, setSelectedProducts] = useState([]);

    useEffect(() => {
        if (show && orderId > 0) {
            getDatas(orderId);
        }
    }, [orderId, show]);

    const getDatas = async (orderId) => {
        const [err, data] = await OrderServices.GetPickProductModelsAsync(orderId);
        if (!err && data) {
            setSelectedProducts(data);
        } else {
            setSelectedProducts([]);
        }
    };

    return (
        <CommonModal
            show={show}
            onClose={onClose}
            onConfirm={() => {
                if (onConfirm) {
                    const selected = selectedProducts.filter((product) => product.selectedQuantity > 0);
                    onConfirm(selected);
                }
            }}
            title="Chọn sản phẩm cần khiếu nại"
            size="lg"
        >
            <Wrapper>
                <div class="modal-content-wrapper">
                    <div class="product-grid">
                        {selectedProducts &&
                            selectedProducts.map((product, index) => (
                                <div
                                    key={index}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        let newProducts = [...selectedProducts];
                                        let currentItem = newProducts[index];
                                        if (currentItem.selectedQuantity === undefined) {
                                            currentItem.selectedQuantity = 0; // Initialize if not set
                                        }
                                        if (currentItem.selectedQuantity < currentItem.quantity) {
                                            currentItem.selectedQuantity = (currentItem.selectedQuantity || 0) + 1;
                                        } else {
                                            currentItem.selectedQuantity = 0; // Reset if already selected
                                        }
                                        setSelectedProducts(newProducts);
                                    }}
                                    class={`cursor-pointer product-card ${product.selectedQuantity > 0 ? "selected" : ""} ${product.status === "sold-out" ? "sold-out" : ""}`}
                                >
                                    {product.selectedQuantity > 0 && <div class="featured-badge">{product.selectedQuantity}</div>}
                                    {product.status === "sold-out" && <div class="sold-out-badge">Bỏ chọn</div>}
                                    <div class="product-image">{product.frontImage ? <img src={product.frontImage} alt={product.name} /> : <img src={product.backImage} alt={product.name} />}</div>
                                    <div class="product-info">
                                        <h4 class="product-name">{product.name}</h4>
                                        <div className="product-quantity">Số lượng: {product.quantity}</div>
                                        <div class="product-details">
                                            <span class="product-size">{product.size}</span>
                                            <span class="product-color">{product.color}</span>
                                        </div>
                                        <div class="product-price">
                                            <span class="current-price">{Common.formatCurrency(product.price)}</span>
                                            <span class="original-price">{product.originalPrice}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </Wrapper>
        </CommonModal>
    );
}

export default PickProductModal;

const Wrapper = styled.div`
    h4.product-name {
        margin: 3px 0;
    }

    .product-quantity {
        margin: 3px 0;
    }

    .product-card.selected {
        background: #febd6a;
    }

    .product-image {
        width: 150px;
        height: 150px;
    }

    .product-image img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .product-grid {
        display: flex;
        flex-wrap: wrap;
    }

    h4.product-name {
        color: #444;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .product-details {
        display: flex;
        justify-content: space-between;
    }

    span.product-size {
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    span.product-color {
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .product-card {
        border: 1px solid #d9d9d9;
        background: #fff;
        margin: 6px;
        padding: 6px 10px;
        position: relative;
        width: 170px;
    }

    span.current-price {
        color: #444;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    span.original-price {
        color: #a4a4a4;
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-decoration-line: line-through;
        margin-left: 5px;
    }

    .featured-badge {
        position: absolute;
        top: 5px;
        right: 5px;
        background: #ff9027;
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        border-radius: 100%;
    }

    .sold-out-badge {
        position: absolute;
        top: calc(50% - 24px);
        left: 0;
        right: 0;
        height: 48px;
        background: rgba(255, 255, 255, 0.7);
        overflow: hidden;
        color: #f96a74;
        text-align: center;
        text-overflow: ellipsis;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .product-card.sold-out .product-image {
        opacity: 0.2;
    }
`;
